import { forwardRef } from "react";

import { Icon, IconProps } from "../icon";

export type XlsIconProps = IconProps;

export const XlsIcon = forwardRef<SVGSVGElement, XlsIconProps>(function XlsIcon(
  props: XlsIconProps,
  ref
) {
  return (
    <Icon
      data-testid="XlsIcon"
      aria-label="xls"
      viewBox="0 0 12 12"
      ref={ref}
      {...props}
    >
      <path d="M8.707 0H1v6h1V1h5v3h3v2h1V2.293L8.707 0zM8 1h.293L10 2.707V3H8V1zm3.699 9.558c0 .296-.073.551-.219.766a1.361 1.361 0 0 1-.622.492c-.269.114-.59.171-.964.171-.182 0-.357-.01-.523-.031s-.324-.05-.472-.089a2.562 2.562 0 0 1-.4-.147v-.772c.203.089.43.17.68.243.251.071.506.106.766.106.212 0 .387-.027.526-.082a.662.662 0 0 0 .314-.239.659.659 0 0 0 .103-.366c0-.148-.04-.273-.12-.376s-.2-.196-.362-.28a5.984 5.984 0 0 0-.602-.277 4.017 4.017 0 0 1-.472-.226c-.148-.084-.28-.183-.396-.297s-.209-.248-.277-.403a1.424 1.424 0 0 1-.099-.554c0-.283.067-.524.202-.725.137-.201.328-.354.574-.461.248-.107.538-.161.868-.161.262 0 .508.027.738.082.232.055.46.132.684.232l-.26.66a4.631 4.631 0 0 0-.598-.202 2.312 2.312 0 0 0-.588-.075c-.173 0-.32.026-.441.079s-.213.126-.277.222a.59.59 0 0 0-.092.335.62.62 0 0 0 .106.369c.073.098.185.188.335.27.153.082.349.173.588.273.276.114.509.234.701.359.194.125.342.276.444.451.103.173.154.391.154.653zM5 6.92v4.997h2.943v-.697H5.82v-4.3H5zm-1.339 5h.933L2.919 9.353l1.555-2.43h-.878L2.441 8.817 1.279 6.923H.373l1.548 2.406L.26 11.92h.878l1.265-2.047 1.258 2.047z" />
    </Icon>
  );
});
